<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> RE: Account # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            This letter is in reference to your response in regards to {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} that is currently being reported to Equifax, Experian and TransUnion. While I appreciate your response, unfortunately, you still have not complied with the FCBA. You have only forwarded a portion of the documentation requested and required by the FCBA.
        </p>
        <p class="letter-content">
            It is my understanding that The Fair Credit Billing Act requires creditors to bill correctly, that each statement be sent to the correct address, that you not ignore change of address requests, that you facilitate disputed charges in a manner as prescribed by law, and also that you provide lawfully requested information concerning my account upon request in a timely manner. Thus, I submitted a formal request for information, which was perfectly within my rights to do, and yet, you have failed to send that information. You have only provided some of the information requested which leaves a lot of gaps and holes in what I need to know. The little bit of information you sent has only led to more questions for me.
        </p>
        <ul>
            <p class="letter-content">Therefore, you are still required to send me:<br></p>
            <li class="letter-content">The contract/agreement I signed legally binding me to this alleged debt<br> </li>
            <li class="letter-content"> The information you used for fraud prevention and to verify my identity as the responsible person qualified to establish this account <br></li>
            <li class="letter-content"> The steps you took to verify my eligibility to establish this account (ie, employment verification, residence verification, etc.) <br></li>
            <li class="letter-content"> Verification of accurate billing (ie, every single itemized statement, payment, credit, interest added, disputed charges, etc.) from the time this alleged account was first established <br></li>
            <li class="letter-content"> A notarized statement on your letterhead which will attest to your compliance to the FCBA generally and to my account specifically throughout the period you claim I was a customer <br></li>
        </ul>
        <p class="letter-content">
            You have only 15 more days to provide this information request and comply with the law. Otherwise, you are required, per the FCRA, to delete the negative marks you have reported to any consumer reporting agencies about me. Failure to do so will force me to seek legal remedies, including punitive damages, for continuing to report an “unverifiable” account which proves your willful non-compliance and negligence. Once again, your prompt attention to this matter would be greatly appreciated.
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br>
            <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>